class TrScrollNextSectionButton extends HTMLElement {
	selectors = {
		button: '[data-tr-js-scroll-next-section-button]'
	};

	attributes = {};

	stateClasses = {};

	connectedCallback() {
		this.buttonElement = this.querySelector(this.selectors.button);
		this.sectionElement = this.closest('.shopify-section');

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);

		this.destroy();
	}

	init() {
		this.hidden = false;
		this.nextSectionElement = this.sectionElement?.nextElementSibling;

		if (!this.nextSectionElement) {
			this.hidden = true;
		}
	}

	bindEvents() {
		this.buttonElement?.addEventListener('click', this.onButtonClick);
		document.addEventListener('shopify:section:load', this.onSectionLoad);
	}

	onSectionLoad = event => {
		if (event.detail.sectionId !== this.sectionElement?.id.replace('shopify-section-', '')) return;

		this.init();
	};

	onButtonClick = () => {
		this.nextSectionElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	destroy() {
		this.buttonElement?.removeEventListener('click', this.onButtonClick);
	}
}

if (!customElements.get('tr-scroll-next-section-button')) {
	customElements.define('tr-scroll-next-section-button', TrScrollNextSectionButton);
}
